import React from 'react';
import { CategoryForView } from '../model/Category';
import DishView from './DishView';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import categoryStyle from './CategoryViewStyle';

interface Props {
  category: CategoryForView;
}

export default function CategoryView(props: Props) {
  const classes = categoryStyle();
  return (
    <Card className={classes.root}>
      <CardHeader
        className={classes.header}
        title={(<Typography variant="h4">{props.category.getName()}</Typography>)}
        subheader={props.category.getSubtitle()}
        subheaderTypographyProps={{ className: classes.subheader }}
      />
      <CardContent className={classes.content}>
        {props.category.getDishes().map((dish, index) => (
          <DishView
            key={index}
            dish={dish}
          />
        ))}
      </CardContent>
    </Card>
  );
}
